function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CouncilOfTrentTemplate = require('./council-of-trent.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var CouncilOfTrentOverlay = /*#__PURE__*/function () {
  function CouncilOfTrentOverlay(app, mod) {
    _classCallCheck(this, CouncilOfTrentOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
    this.selected = [];
  }
  return _createClass(CouncilOfTrentOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'papacy';
      this.selected = [];
      var papacy_player = this.mod.returnPlayerOfFaction('papacy');
      var protestants_player = this.mod.returnPlayerOfFaction('protestant');
      this.visible = true;
      this.overlay.show(CouncilOfTrentTemplate());
      if (stage == 'papacy') {
        var debaters = this.mod.returnDebaters('papacy', 'uncommitted');
        for (var i = 0; i < debaters.length; i++) {
          this.app.browser.addElementToSelector(this.mod.returnCardImage(debaters[i].type), '.council-of-trent-overlay .debaters');
        }
        if (this.mod.game.player != papacy_player) {
          document.querySelector('.council-of-trent-overlay .help').innerHTML = 'Papacy is selecting up to 4 Debaters.';
        } else {
          document.querySelector('.council-of-trent-overlay .help').innerHTML = "Papacy - select up to 4 Debaters. (<span class=\"finish-selecting-debaters\">click when done</span>)";
        }
      }
      if (stage == 'protestant') {
        var _debaters = this.mod.returnDebaters('protestant', 'uncommitted');
        for (var _i = 0; _i < _debaters.length; _i++) {
          this.app.browser.addElementToSelector(this.mod.returnCardImage(_debaters[_i].type), '.council-of-trent-overlay .debaters');
        }
        if (this.mod.game.player != protestants_player) {
          document.querySelector('.council-of-trent-overlay .help').innerHTML = 'Protestants are selecting up to 2 Debaters.';
        } else {
          document.querySelector('.council-of-trent-overlay .help').innerHTML = "Protestants - select up to 2 Debaters. (<span class=\"finish-selecting-debaters\">click when done</span>)";
        }
      }
      if (stage == 'results') {
        var papacy_total = 0;
        var protestants_total = 0;
        var papacy_rolls = [];
        var protestants_rolls = [];
        var papacy_hits = 0;
        var protestants_hits = 0;
        for (var _i2 = 0; _i2 < this.mod.game.state.council_of_trent.papacy.debaters.length; _i2++) {
          var d = this.mod.debaters[this.mod.game.state.council_of_trent.papacy.debaters[_i2]];
          papacy_total += d.power;
        }
        for (var _i3 = 0; _i3 < this.mod.game.state.council_of_trent.protestants.debaters.length; _i3++) {
          var _d = this.mod.debaters[this.mod.game.state.council_of_trent.protestants.debaters[_i3]];
          protestants_total += _d.power;
        }
        for (var _i4 = 0; _i4 < papacy_total; _i4++) {
          papacy_rolls.push(this.mod.rollDice(6));
        }
        for (var _i5 = 0; _i5 < protestants_total; _i5++) {
          protestants_rolls.push(this.mod.rollDice(6));
        }
        for (var _i6 = 0; _i6 < papacy_rolls.length; _i6++) {
          if (papacy_rolls[_i6] >= 5) {
            papacy_hits++;
          }
        }
        for (var _i7 = 0; _i7 < protestants_rolls.length; _i7++) {
          if (protestants_rolls[_i7] >= 5) {
            protestants_hits++;
          }
        }
        var html = 'Papacy rolls: ' + JSON.stringify(papacy_rolls) + '<br />';
        html += 'Protestants roll: ' + JSON.stringify(protestants_rolls) + '<br />';
        var winner = "Council of Trent inconclusive (<span class=\"continue_inconclusive\">click here</span>)";
        var winner_converts = 0;
        if (protestants_hits > papacy_hits) {
          winner_converts = protestants_hits - papacy_hits;
          winner = "Protestants may convert ".concat(winner_converts, " space(s) (<span class=\"continue_protestants\">click here</a>)");
          html += winner;
          for (var _i8 = 0; _i8 < winner_converts; _i8++) {
            this.mod.game.queue.push('select_for_protestant_conversion\tprotestant\tall');
          }
          this.mod.game.queue.push('ACKNOWLEDGE\tProtestants win the Council of Trent');
        }
        if (protestants_hits < papacy_hits) {
          winner_converts = papacy_hits - protestants_hits;
          winner = "Papacy may convert ".concat(winner_converts, " space(s) (<span class=\"continue_papacy\">click here</a>)");
          html += winner;
          for (var _i9 = 0; _i9 < winner_converts; _i9++) {
            this.mod.game.queue.push('select_for_catholic_conversion\tpapacy\tall');
          }
          this.mod.game.queue.push('ACKNOWLEDGE\tPapacy wins the Council of Trent');
        }
        if (protestants_hits === papacy_hits) {
          document.querySelector('.council-of-trent-overlay .help').innerHTML += 'Council Inconclusive - No Winner';
          this.mod.game.queue.push('ACKNOWLEDGE\tThe Council of Trent is Inconclusive');
        }
        document.querySelector('.council-of-trent-overlay .help').innerHTML = html;
        var his_self = this.mod;
        $('.continue_inconclusive').off();
        $('.continue_inconclusive').on('click', function () {
          _this.overlay.remove();
        });
        $('.continue_protestants').off();
        $('.continue_protestants').on('click', function () {
          _this.overlay.remove();
        });
        $('.continue_papacy').off();
        $('.continue_papacy').on('click', function () {
          _this.overlay.remove();
        });
      }
      if (stage == 'results') {
        this.attachEvents(stage);
      }
      if (this.mod.game.player == papacy_player && stage == 'papacy' || this.mod.game.player == protestants_player && stage == 'protestant') {
        this.attachEvents(stage);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'papacy';
      var papacy_player = this.mod.returnPlayerOfFaction('papacy');
      var protestants_player = this.mod.returnPlayerOfFaction('protestant');
      try {
        document.querySelector('.finish-selecting-debaters').onclick = function (e) {
          document.querySelector('.finish-selecting-debaters').onclick = function (e) {};
          if (_this2.mod.game.player == papacy_player && stage == 'papacy') {
            _this2.mod.addMove('council_of_trent_add_debaters\tpapacy\t' + JSON.stringify(_this2.selected));
            _this2.mod.endTurn();
          }
          if (_this2.mod.game.player == protestants_player && stage == 'protestant') {
            _this2.mod.addMove('council_of_trent_add_debaters\tprotestant\t' + JSON.stringify(_this2.selected));
            _this2.mod.endTurn();
          }
        };
      } catch (err) {}
      try {
        document.querySelectorAll('.council-of-trent-overlay .debaters .debater-card').forEach(function (el) {
          el.onclick = function (e) {
            var el = e.currentTarget;
            var debater = e.currentTarget.id;
            if (el.classList.contains('opaque')) {
              el.classList.remove('opaque');
              for (var i = 0; i < _this2.selected.length; i++) {
                if (_this2.selected[i] == debater) {
                  _this2.selected.splice(i, 1);
                }
              }
            } else {
              if (stage === 'papacy') {
                if (_this2.selected.length >= 4) {
                  alert('You can at most select 4 debaters');
                  return;
                }
              }
              if (stage === 'protestant') {
                if (_this2.selected.length >= 2) {
                  alert('You can at most select 2 debaters');
                  return;
                }
              }
              el.classList.add('opaque');
              if (!_this2.selected.includes(debater)) {
                _this2.selected.push(debater);
              }
            }
          };
        });
      } catch (err) {}
    }
  }]);
}();
module.exports = CouncilOfTrentOverlay;